export default async function wait(ms = 300) {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    });
}
